export default "__VITE_ASSET__CBVjj1ya__"